


















































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { MESSAGE } from "@/model/Message";
import { ExtendsImageInspectVO, ExtendsImageVO } from "@/model/ExtendsImage";
import { Getter } from "vuex-class";
import requestService from "@/service/requestService";
import { ExtendsImageService } from "@/service/ExtendsImageService";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import draggable from "vuedraggable";

@Component({
  components: { 
    draggable,
    ConfirmDialog, 
  }
})
export default class ExtendsImageContent extends Vue {

  @Prop({ default: 'seibi' }) imageType: 'car'|'seibi'; // 車両画像, 整備画像
  @Prop({ default: true }) hasLeftSideBar: boolean; // true:左サイドバー有り（車両画像+整備複数）, false:左サイドバー無し（整備1つのみ、または整備複数+前へ次へボタン）

  // 左サイドバー無しの場合は、extendsImageInspect または extendsImageWorkList+openedCurrentIndex のどちらかが必須。
  @Prop({ default: null }) extendsImageInspect: ExtendsImageInspectVO;
  @Prop({ default: null }) extendsImageWorkList: ExtendsImageInspectVO[]; // 作業+画像の配列（前へ次へボタンの対象）
  @Prop({ default: 0 }) openedCurrentIndex: number; // ダイアログを開いた時点でのcurrentIndex

  @Getter("isCanExtendsImage", { namespace: "FunctionSetting" })
  isCanExtendsImage: any;

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;

  reqService: requestService = new requestService();
  extendsImageService: ExtendsImageService = new ExtendsImageService();
  loading: boolean = false;
  loadingText: string = MESSAGE.Loading;
  errorMsg: string = "";
  isUserMode: boolean = false;

  currentIndex: number = -1; // extendsImageWorkListのindex

  leftSideBarItems: {car: ExtendsImageInspectVO[], seibi: ExtendsImageInspectVO[]} = {car: [], seibi: []};
  activeInspect: ExtendsImageInspectVO = {
    sknUketsukeInspectId: null,
    carImageMenuId: null,
    label: "",
    imageList: null
  };
  leftSideBarHeight: number = 700; // 左サイドバーの高さ

  thumbnailLabelList: string[] = [];
  thumbnailImageList: Array<ExtendsImageVO | null> = []; // サムネイルとメイン画像用
  thumbnailImageListOld: Array<ExtendsImageVO | null>; // 順番入替キャンセル用のバックアップ
  mainImage: ExtendsImageVO|null = null; // メイン画像

  mode: 0|1|2 = 0; // 0:通常, 1:順番入替モード, 2:削除モード
  uploadImageCount: {complete: number, total: number} = {complete: 0, total: 0};

  $refs!: {
    errorDialog: ConfirmDialog;
  };

  created() {
    this.isUserMode = this.$route.meta === "user";
    if (!this.isCanExtendsImage) {
      return;
    }
    if (!this.hasLeftSideBar) {
      this.onDialogOpen(this.extendsImageInspect, this.extendsImageWorkList, this.openedCurrentIndex);
      return;
    } else {
      // 左サイドバー有りの場合のみソケットで更新検知する（無しの場合は親画面で更新検知する）
      this.extendsImageService.connectSocket(this.extendsImageSocketCallback);
    }
    this.loading = true; // メイン画像読み込み完了までローディングを表示
    this.reqService.getExtendsImageInspect(this.uketsukeExtendsId).then(
      (res: any) => {
        this.leftSideBarItems = res;
        this.onChangeImageType();
      },
      (err: any) => {
        this.errorMsg = MESSAGE.SystemError;
        this.$refs.errorDialog.onOpen();
        this.loading = false;
      }
    );
  }
  onDialogOpen(extendsImageInspect: ExtendsImageInspectVO|null
    , extendsImageWorkList: ExtendsImageInspectVO[]|null, openedCurrentIndex: number) {
    if (this.isChangeOrderMode) {
      this.onCancelChangeOrder();
    } else if (this.isDeleteMode) {
      this.onCancelDelete();
    }
    if (extendsImageInspect) {
      // 前へ次へボタン無し
      this.activeInspect = extendsImageInspect;
    } else {
      // 前へ次へボタン有り
      this.currentIndex = openedCurrentIndex;
      this.activeInspect = extendsImageWorkList![this.currentIndex];
    }
    this.refreshThumbnailList();
  }
  beforeDestroy() {
    if (this.hasLeftSideBar) {
      this.extendsImageService.destroy(); // ソケット切断
    }
  }

  extendsImageSocketCallback(updatedList: ExtendsImageInspectVO[]) {
    this.$message({
      message: MESSAGE.UpdatedImage,
      type: "info",
      duration: 700,
      customClass: "msg-center shadow",
      showClose: true
    });
    let isActiveInspectChanged: boolean = false;
    if (updatedList[0].carImageMenuId) {
      // 車両画像の場合は全件送られてくるので丸ごと置き換える
      this.leftSideBarItems.car = updatedList;
      isActiveInspectChanged = this.isCarImage;
    } else {
      // 整備画像の場合は1件だけ送られてくるので探して置き換える
      const index = this.leftSideBarItems.seibi.findIndex(
        item => item.sknUketsukeInspectId === updatedList[0].sknUketsukeInspectId
      );
      if (index !== -1) {
        this.leftSideBarItems.seibi[index] = updatedList[0];
        isActiveInspectChanged = this.activeInspect.sknUketsukeInspectId === updatedList[0].sknUketsukeInspectId;
      } else {
        // 無ければ末尾に追加する
        this.leftSideBarItems.seibi.push(updatedList[0]);
      }
    }
    if (isActiveInspectChanged) {
      if (this.isChangeOrderMode) {
        this.onCancelChangeOrder();
      } else if (this.isDeleteMode) {
        this.onCancelDelete();
      }
      // 新しい左サイドバーから現在のactiveInspectを取得して再設定する
      let newActiveInspect: ExtendsImageInspectVO | null
        = this.leftSideBarItems[this.imageType].find(sideBarItem => this.isActiveInspect(sideBarItem)) || null;
      this.onSelectLeftSideBarItem(newActiveInspect);
    }
  }

  /******** 左サイドバー ********/

  get isCarImage(): boolean {
    return this.imageType === 'car';
  }

  // 車両画像/整備画像の切り替え時
  @Watch('imageType')
  onChangeImageType() {
    if (this.isChangeOrderMode) {
      this.onCancelChangeOrder();
    } else if (this.isDeleteMode) {
      this.onCancelDelete();
    }
    if (!this.hasLeftSideBar) {
      return;
    }

    this.onSelectLeftSideBarItem();
    this.setLeftSideBarHeight();
  }

  // 左サイドバー選択時
  onSelectLeftSideBarItem(sideBarItem: ExtendsImageInspectVO|null = null) {
    if (!sideBarItem) {
      sideBarItem = this.leftSideBarItems[this.imageType][0]; // 引数省略の場合はサイドバーの先頭を選択
    }
    this.activeInspect = sideBarItem!;
    this.refreshThumbnailList();
    if (!this.mainImage) {
      this.loading = false; // メイン画像が無い場合はローディング解除
    }
  }
  setLeftSideBarHeight() {
    const el = document.getElementById('app');
    if (!el) {
      return;
    }
    this.leftSideBarHeight = el.clientHeight - 338;
  }

  tableRowClassName(scope: any) {
    const list = ['image-cate-item'];
    if (this.isActiveInspect(scope.row)) {
      list.push('item-active');
    }
    return list.join(' ');
  }

  isActiveInspect(inspect: ExtendsImageInspectVO): boolean {
    return (inspect.carImageMenuId !== null && inspect.carImageMenuId === this.activeInspect.carImageMenuId)
        || (inspect.sknUketsukeInspectId !== null 
        && inspect.sknUketsukeInspectId === this.activeInspect.sknUketsukeInspectId);
  }

  changeActiveInspect(image: ExtendsImageVO|null = null) {
    if (!this.hasLeftSideBar || !this.isCarImage) {
      return;
    }
    const carImageMenuId = image ? image.carImageMenuId : (this.mainImage ? this.mainImage.carImageMenuId : null);
    if (carImageMenuId && carImageMenuId !== this.activeInspect.carImageMenuId) {
      this.activeInspect = this.leftSideBarItems.car.find(
        (sideBarItem: any) => sideBarItem.carImageMenuId === carImageMenuId)!;
    }
  }

  /******** メイン画像とサムネイル ********/

  refreshThumbnailList() {
    if (this.isCarImage) {
      // 車両画像の場合はメニューのラベル3つと画像8枚
      const sideBarItems: ExtendsImageInspectVO[] = this.leftSideBarItems.car;
      this.thumbnailLabelList = sideBarItems.map((item: ExtendsImageInspectVO) => item.label);
      this.thumbnailImageList = this.fillThumbnailList(sideBarItems[0].imageList, 4)
        .concat(this.fillThumbnailList(sideBarItems[1].imageList, 2))
        .concat(this.fillThumbnailList(sideBarItems[2].imageList, 2));
    } else {
      // 整備画像の場合は整備名1つと画像4枚
      this.thumbnailLabelList = [this.activeInspect.label];
      this.thumbnailImageList = this.fillThumbnailList(this.activeInspect.imageList, 4);
    }

    if (!this.activeInspect.imageList || !this.activeInspect.imageList[0]) {
      this.mainImage = null;
    } else if (!this.mainImage || this.mainImage.isDelete || !this.activeInspect.imageList.includes(this.mainImage)) {
      this.mainImage = this.activeInspect.imageList[0];
    }
  }
  // 配列の要素数が規定数になるまでnullを追加する
  fillThumbnailList(list: Array<ExtendsImageVO | null> | null, length: number) {
    if (!list) {
      list = [];
    }
    if (list.length >= length) {
      return list;
    }
    const ret: Array<ExtendsImageVO | null> = [...list]; // 引数を破壊しないよう複製
    ret.length = length;
    ret.fill(null, list.length);
    return ret;
  }

  onMainImageLoad() {
    this.loading = false;
  }

  onSelectImage(image: ExtendsImageVO) {
    if (!image || !image.url) {
      return;
    }
    this.mainImage = image;
    this.changeActiveInspect(image); // 車両画像の場合は選択された画像に合わせて左サイドバーのアクティブを変更する
    if (this.isDeleteMode) {
      // 削除モードの場合はサムネイルクリックでON/OFF切り替え
      this.checkDelete(image);
    }
  }

  /******** 右サイドのボタン ********/

  // 画像枚数制限
  get limit() {
    let maxImageCount = 4; // 画像枚数（最大）
    let imageCount = 0;    // 画像枚数（現在）
    if (this.activeInspect) {
      if (this.isCarImage && this.activeInspect.carImageMenuId !== 1) {
        // 車両画像メニューの「車台同一性の確認」または「完成検査時の状態」を選択中なら最大画像枚数が2
        maxImageCount = 2;
      }
      imageCount = this.activeInspect.imageList ? this.activeInspect.imageList.length : 0;
    }
    return maxImageCount - imageCount;
  }
  // 画像追加ボタンでファイル選択時に画像枚数超過
  onExceed() {
    this.errorMsg = MESSAGE.ExceedImage;
    this.$refs.errorDialog.onOpen();
  }

  // 画像追加ボタンでファイル選択時に実行（複数ファイルなら複数回実行）
  beforeUpload(file: File) {
    this.$set(this, "loadingText", MESSAGE.Uploading + "   (" 
      + this.uploadImageCount.complete + "/" + ++this.uploadImageCount.total + ")");
    this.loading = true;
    this.resizeImage(file).then(
      (blob: Blob | null) => {
        if (!blob) {
          this.errorMsg = "リサイズ失敗";
          this.$refs.errorDialog.onOpen();
          console.error("リサイズ失敗(blobが空)");
          this.loading = false;
          return false;
        }
        const resizedFile = new File([blob], "imageFile.jpg", {type: "image/jpeg"});
        this.upload(resizedFile, file.lastModified);
      },
      (err: any) => {
        this.errorMsg = "リサイズ失敗";
        this.$refs.errorDialog.onOpen();
        console.error("リサイズ失敗", err);
        this.loading = false;
      }
    );

    return false;
  }

  async resizeImage(imageData: File): Promise<Blob | null> {
    // 最大値はiPad横向きでダイアログで開いた際に等倍で表示できる値で調整済み
    // ※参考：iPadで撮影した3264*2448のPNG(1.4MB) → 948*711のJPG(67KB)
    const maxWidth = 1039;
    const maxHeight = 711;
    try {
      const context = document.createElement('canvas').getContext('2d');
      if (context == null) {
        return null;
      }

      // 画像のサイズを取得
      const image: HTMLImageElement = await new Promise((resolve, reject) => {
        const url = URL.createObjectURL(imageData);
        const tgtImage = new Image();
        const onLoad = () => {
          cleanup();
          resolve(tgtImage);
        };
        const onError = (e: any) => {
          cleanup();
          reject(e);
        };
        const cleanup = () => {
          URL.revokeObjectURL(url);
          tgtImage.removeEventListener('load', onLoad);
          tgtImage.removeEventListener('error', onError);
        };
        tgtImage.addEventListener('load', onLoad);
        tgtImage.addEventListener('error', onError);
        tgtImage.src = url;
      });      
      const { naturalHeight: beforeHeight, naturalWidth: beforeWidth } = image;

      if (beforeWidth <= maxWidth && beforeHeight <= maxHeight && imageData.type === `image/jpeg`) {
        return imageData;
      }
      // 変換後の高さと幅を算出
      let afterWidth: number = beforeWidth;
      let afterHeight: number = beforeHeight;
      if (afterWidth > maxWidth) {
        afterHeight = Math.floor(afterHeight * (maxWidth / afterWidth));
        afterWidth = maxWidth;
      }
      if (afterHeight > maxHeight) {
        afterWidth = Math.floor(afterWidth * (maxHeight / afterHeight));
        afterHeight = maxHeight;
      }

      // Canvas 上に描画
      context.canvas.width = afterWidth;
      context.canvas.height = afterHeight;
      context.drawImage(image, 0, 0, beforeWidth, beforeHeight, 0, 0, afterWidth, afterHeight);

      // JPEGデータにして返す
      return await new Promise((resolve) => {
        context.canvas.toBlob(resolve, `image/jpeg`, 0.9);
        context.canvas.width = context.canvas.height = 0;
      });
    } catch (err) {
      console.error(err);
      return null;
    }
  }

  upload(resizedFile: File, lastModified: number) {
    const data = new FormData();
    data.append('imageFile', resizedFile);
    data.append('sknUketsukeInspectId', String(this.activeInspect.sknUketsukeInspectId || ''));
    data.append('carImageMenuId', String(this.activeInspect.carImageMenuId || ''));
    let photographedAt: string = "";
    if (lastModified) {
      const dateFormat: Intl.DateTimeFormatOptions // yyyy/MM/dd HH:mm:ss
        = {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'};

        // yyyy-MM-dd HH:mm:ss
      photographedAt = new Date(lastModified).toLocaleString('ja-JP', dateFormat).replace(/\//g, "-");
    }
    data.append('photographedAt', photographedAt);
    this.reqService.uploadExtendsImage(data, this.uketsukeExtendsId).then(
      (res: any) => {
        this.afterUpload(res);
      },
      (err: any) => {
        this.errorMsg = MESSAGE.SystemError;
        this.$refs.errorDialog.onOpen();
        this.loading = false;
      }
    );
  }

  afterUpload(image: ExtendsImageVO) {
    if (!this.hasLeftSideBar) {
      // 左サイドバー無しの場合は画像リストに追加する（有りの場合はソケット経由で更新するためここでは触らない）
      if (!this.activeInspect.imageList) {
        this.activeInspect.imageList = [];
      }
      this.activeInspect.imageList.push(image);
    }
    if (++this.uploadImageCount.complete < this.uploadImageCount.total) {
      this.$set(this, "loadingText", MESSAGE.Uploading + "   (" 
        + this.uploadImageCount.complete + "/" + this.uploadImageCount.total + ")");
    } else {
      this.refreshThumbnailList();
      this.$set(this, "loadingText", MESSAGE.Loading);
      this.uploadImageCount = {complete: 0, total: 0};
      this.loading = false;
      this.updateCompleted();
    }
  }

  // 画像登録画面の画像追加、順番入替、削除は複数APIを並列実行するので、完了時に通知して、ソケット伝播させる
  updateCompleted() {
    this.reqService.updateCompletedExtendsImageInspect(this.uketsukeExtendsId, this.activeInspect.sknUketsukeInspectId);
  }

  // 画像の有無チェック（順番入替ボタンと画像削除ボタンの表示制御用）
  exist() {
    if (this.isCarImage) {
      // 車両画像の場合は全ての画像有無
      return this.leftSideBarItems && this.leftSideBarItems.car 
        && this.leftSideBarItems.car.some((item: any) => item.imageList && item.imageList.length);
    } else {
      // 整備画像の場合は選択している整備の画像有無
      return this.activeInspect && this.activeInspect.imageList && this.activeInspect.imageList.length;
    }
  }

  get isDefaultMode(): boolean {
    return this.mode === 0;
  }
  get isChangeOrderMode(): boolean {
    return this.mode === 1;
  }
  get isDeleteMode(): boolean {
    return this.mode === 2;
  }
  resetMode() {
    this.mode = 0;
  }
  @Watch('mode')
  onChangeMode() {
    this.$emit('mode-changed', this.mode);
  }

  // 順番入替モード開始
  changeOrder() {
    this.mode = 1;
    this.thumbnailImageListOld = [...this.thumbnailImageList];
  }
  // 順番入替キャンセル
  onCancelChangeOrder() {
    this.thumbnailImageList = this.thumbnailImageListOld;
    this.thumbnailImageListOld = [];
    this.resetMode();
  }
  // 順番確定
  onConfirmChangeOrder() {
    this.loading = true;
    let updatedImageList: ExtendsImageVO[] = [];
    // 前詰めして、leftSideBarItemsに反映
    if (this.isCarImage) {
      // 車両画像
      const slicedImageList = [
        this.thumbnailImageList.slice(0, 4),
        this.thumbnailImageList.slice(4, 6),
        this.thumbnailImageList.slice(6, 8),
      ];
      for (const sideBarItem of this.leftSideBarItems.car) {
        sideBarItem.imageList = this.trimThumbnailImageList(slicedImageList.shift()!, sideBarItem.carImageMenuId!);
        updatedImageList = updatedImageList.concat(sideBarItem.imageList);
      }

    } else {
      // 整備画像
      this.activeInspect.imageList = this.trimThumbnailImageList(this.thumbnailImageList);
      updatedImageList = this.activeInspect.imageList;
    }
    this.changeActiveInspect();
    this.refreshThumbnailList();
    this.thumbnailImageListOld = [];

    // DB更新
    const promiseList = [];
    for (const image of updatedImageList) {
      promiseList.push(this.reqService.updateExtendsImage(image));
    }
    Promise.all(promiseList).then(
      (val: any) => {
      }, (err: any) => {
        window.console.error(err);
        this.errorMsg = MESSAGE.SystemError;
        this.$refs.errorDialog.onOpen();
      }
    ).then(() => {
      this.loading = false;
      this.resetMode();
      this.updateCompleted();
    });
  }
  // 配列からnullを除去して、displayOrderを振りなおす
  trimThumbnailImageList(list: Array<ExtendsImageVO | null>, carImageMenuId: number | null = null): ExtendsImageVO[] {
    const ret: ExtendsImageVO[] = [];
    if (!list) {
      return ret;
    }
    let displayOrder = 1;
    for (const item of list) {
      if (!item) {
        continue;
      }
      item.displayOrder = displayOrder++;
      if (carImageMenuId) {
        item.carImageMenuId = carImageMenuId;
      }
      ret.push(item);
    }
    return ret;
  }

  // 削除モード開始
  deleteImage() {
    this.mode = 2;
  }
  // 削除キャンセル
  onCancelDelete() {
    this.clearIsDelete();
    this.resetMode();
  }
  clearIsDelete() {
    for (const image of this.thumbnailImageList) {
      if (image) {
        this.$delete(image, "isDelete");
      }
    }
  }
  // 削除対象チェックON/OFF
  checkDelete(image: ExtendsImageVO) {
    this.$set(image, "isDelete", !image.isDelete);
    this.$forceUpdate();
  }
  // 削除確定
  onConfirmDelete() {
    this.loading = true;
    const promiseList = [];
    for (const image of this.thumbnailImageList) {
      if (image && image.isDelete) {
        promiseList.push(this.reqService.deleteExtendsImage(image.id!));
      }
    }
    Promise.all(promiseList).then(
      (val: any) => {
        if (!this.hasLeftSideBar) {
          // 左サイドバー無しの場合は画像リストから削除する（有りの場合はソケット経由で更新するためここでは触らない）
          if (this.isCarImage) {
            // 車両画像
            for (const sideBarItem of this.leftSideBarItems.car) {
              if (sideBarItem.imageList) {
                sideBarItem.imageList = sideBarItem.imageList.filter((image: any) => !image.isDelete);
              }
            }
          } else {
            // 整備画像
            this.activeInspect.imageList = this.activeInspect.imageList!.filter((image: any) => !image.isDelete);
          }
          this.refreshThumbnailList();
        }
        this.loading = false;
      }, (err: any) => {
        window.console.error(err);
        this.errorMsg = MESSAGE.SystemError;
        this.$refs.errorDialog.onOpen();
      }
    ).then(() => {
      this.loading = false;
      this.clearIsDelete();
      this.resetMode();
      this.updateCompleted();
    });
  }

  close() {
    this.currentIndex = -1;
    this.$emit('close');
  }

  get isShowPrev(): boolean {
    return !this.hasLeftSideBar && this.extendsImageWorkList && this.currentIndex > 0;
  }
  get isShowNext(): boolean {
    return !this.hasLeftSideBar && this.extendsImageWorkList && 
      this.currentIndex < this.extendsImageWorkList.length - 1;
  }
  goPrev(event: any) {
    event.preventDefault();
    if (this.isShowPrev) {
      this.currentIndex--;
      this.activeInspect = this.extendsImageWorkList[this.currentIndex];
      this.refreshThumbnailList();
    }
  }
  goNext(event: any) {
    event.preventDefault();
    if (this.isShowNext) {
      this.currentIndex++;
      this.activeInspect = this.extendsImageWorkList[this.currentIndex];
      this.refreshThumbnailList();
    }
  }
}
